import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ResultHelpers } from '@treneo/models';

import { coursesApi } from '../api';
import { COURSES_QUERY_KEY } from '../courses-query-keys';

export const useCreateCourseMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: Parameters<typeof coursesApi.createCourse>[0]) => {
      const result = await coursesApi.createCourse(request);
      return ResultHelpers.unwrap(result, 'Create course failed');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [COURSES_QUERY_KEY] });
    }
  });
};
